<template>
	<div id="loading">
		<Spin fix>
			<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
			<div>Loading</div>
		</Spin>
	</div>
</template>

<script>
	export default {
		name: "loading",
		data() {
			return {};
		},
		methods: {
		},
	};
</script>

<style>
</style>
